import { SVGProps } from 'react'

export const LineBar = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width={18}
		height={22}
		viewBox="0 0 18 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="m13.7 4 1.4-1.7-1.1-.9L11.9 4H8.7C8.3 2.2 6.7.9 4.8.9s-4 1.8-4 4 1.8 4 4 4 1.3-.2 1.8-.4l3.6 4.5v6.9H7.9v1.4h6v-1.4h-2.3V13l6.2-7.5V4.2h-4.2zm-3.5 2.5c0-.2.1-.5.3-.7.2-.3.6-.5.8-.5h.3c.1.1.2.3.2.4 0 .2-.1.5-.3.7s-.4.4-.7.4h-.4c-.1 0-.2-.3-.1-.5zm2.9-1.1H16l-5 6.2-5-6.2h3.2q-.3.6-.3 1.2c0 .6.2 1.2.6 1.5.4.4 1 .5 1.6.4.5-.1 1.1-.4 1.4-.9.4-.5.6-1 .6-1.6zM4.9 2.3C6 2.3 7 3 7.3 4H4.1v1.3l1.6 2c-.3.1-.6.2-.9.2-1.4 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6z"
			fill="currentColor"
		/>
	</svg>
)
